"use client";

interface BrandEmptyStateProps {
  brandName?: string;
  onExplore?: () => void;
  onBack?: () => void;
}

export default function BrandEmptyState({ brandName, onExplore, onBack }: BrandEmptyStateProps) {
  const headline = brandName?.trim() ? `We couldn't find ${brandName.trim()}` : "Brand not found";

  return (
    <div className="flex min-h-screen flex-col bg-white">
      <div className="mx-auto w-full max-w-4xl flex-1 px-4 py-16">
        <div className="rounded-xl border border-dashed border-divider bg-surface-muted p-10 text-center">
          <p className="text-caption uppercase tracking-wide text-ink-muted">brand unavailable</p>
          <h2 className="mt-4 text-title font-medium text-ink">{headline}</h2>
          <p className="mt-4 text-body leading-relaxed text-ink-secondary">
            This brand does not exist in our catalog. You can browse the full directory to find a
            similar label or return to the main feed to continue exploring.
          </p>

          <div className="mt-8 flex flex-wrap justify-center gap-4">
            {onExplore && (
              <button
                onClick={onExplore}
                className="rounded-full border border-divider bg-white px-5 py-2.5 text-caption text-ink transition-colors hover:bg-ink hover:text-white"
              >
                Browse brands
              </button>
            )}
            {onBack && (
              <button
                onClick={onBack}
                className="text-caption text-ink-secondary underline-offset-4 hover:text-ink hover:underline"
              >
                Return home
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
